<template>
  <div>
    <shop-header :store-id="storeid"/>
    <form @submit.prevent="placeOrder">
      <div class="container main-container">
        <div class="row">
          <div class="col-sm-7 col-xl-8">
            <div class="bg-white py-4 mb-2">
              <div class="p-4 d-flex justify-content-center">
                <div class="w-85">
                  <h4>Getting your giftcard</h4>

                  <my-detail
                    v-if="!user"
                    ref="myDetails"
                    :edit-model="detailModel"
                    @save-user="saveUser"
                    :for-gift="true"
                  />

                  <payment
                    ref="payment"
                    :user="user"
                    :dbuser="dbuser"
                    :edit-model="paymentModel"
                    @save-credit="saveCredit"
                  />
                  <div v-show="error" class="w-100 mt-4">
                    <div class="alert alert-danger" role="alert">
                      <strong>{{ error }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-5 col-xl-4">
            <ShoppingCart
              ref="shoppingCart"
              :proccessing="proccessing"
              :order-type="orderType"
              order-mode
            />
          </div>
        </div>
      </div>
    </form>
    <shopfooter/>
  </div>
</template>
<script>
import MyDetail from "../../../components/shop/Checkout/partials/MyDetail";
import ShoppingCart from "./../giftshoppingcart/GiftShoppingCart";
import Payment from "../../../components/shop/Checkout/partials/Payment";
import ShopHeader from "../../../components/shop/partials/shopheader";
import shopfooter from "./../../shared/shopfooter";
import { getStore } from "../../../api/services/storeService.js";
import shared from "../../../sharedscripts/shop/Checkout/giftCheckout.js";
import { logger } from "./../../../api/Logger.js";
export default {
  components: {
    MyDetail,
    Payment,
    ShoppingCart,
    ShopHeader,
    shopfooter
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      error: "",
      userIsExist: false,
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: ""
      },
      isDelivery: true,
      deliveryAddressModel: {
        StreetAddress: "",
        PostalCode: "",
        CityTown: "",
        DeliveryInstructions: "",
        State: "",
        Altitude: "",
        Longitude: ""
      },
      paymentModel: {
        CardHolder: "",
        CardNumber: "",
        ExpireDate: "",
        CVV: "",
        SelectedCard: null
      },
      registerNew: false,
      saveCard: false,
      payByCard: false,
      store: {},
      dbuser: {},
      proccessing: false
    };
  },

  computed: {
    ...shared.computed
  },
  watch: {
    holder() {
      this.paymentModel.CardHolder = this.holder;
    }
  },
  mounted() {
    let that = this;
    getStore(this.storeid)
      .get()
      .then(function(doc) {
        that.setStoreLoaded();
        if (doc.exists) {
          that.store = doc.data();
        }
      })
      .catch(reason => {
        logger.log(
          reason.name,
          reason.toString(),
          that.$router.currentRoute.fullPath,
          logger.LogType.Error
        );
        that.$router.replace("/GeneralError");
      });
  },
  methods: {
    ...shared.methods,
    setUserIsExist(value) {
      this.userIsExist = value;
    }
  }
};
</script>
